import { register } from '!/repository'
import { model as sessionModel } from '$/session'
import { combine, createEvent, sample } from 'effector'
import { tvFavoritesEntityModel } from '~/entities/tv/favorites'
import { nay } from '~/shared/helpers'
import { libraryGridFavoritesTvChannelsWidget } from '~/widgets/library/grid/favorites/tvChannels'
import { $libraryFavoritesTvChannelsTranslations } from './translations'

export const initLibraryFavoritesTvChannelsPage = createEvent()
export const leftLibraryFavoritesTvChannelsPage = createEvent()

sample({
  clock: initLibraryFavoritesTvChannelsPage,
  target: libraryGridFavoritesTvChannelsWidget.loadGridFavoritesTvChannels,
})

export const $isLibraryFavoritesTvChannelsEmptyPage = combine(
  tvFavoritesEntityModel.$onlyFavoritesTvChannelsGrid,
  (onlyFavoritesTvChannelsGrid) =>
    onlyFavoritesTvChannelsGrid && !onlyFavoritesTvChannelsGrid.content.length
)

sample({
  clock: [
    initLibraryFavoritesTvChannelsPage,
    leftLibraryFavoritesTvChannelsPage,
  ],
  target: tvFavoritesEntityModel.resetOnlyFavoritesTvChannelsGrid,
})

sample({
  clock: sessionModel.$authenticated,
  filter: nay,
  target: tvFavoritesEntityModel.resetOnlyFavoritesTvChannelsGrid,
})

register(
  $libraryFavoritesTvChannelsTranslations,
  '$libraryFavoritesTvChannelsTranslations'
)
register(
  tvFavoritesEntityModel.$onlyFavoritesTvChannelsGridFormatted,
  '$library/favorites/tvChannels/onlyFavoritesTvChannelsGridFormatted'
)
register(
  $isLibraryFavoritesTvChannelsEmptyPage,
  '$isLibraryFavoritesTvChannelsEmptyPage'
)
register(
  libraryGridFavoritesTvChannelsWidget.loadMoreGridFavoritesTvChannels,
  'loadMoreGridFavoritesTvChannels'
)
